<template>
<div id="ServiceCodePrereqServiceCodes">
 
 <b-modal id="ServiceCodePrereqServiceCodesAddEdit"   size=lg v-model="showEditModal"  no-close-on-esc no-close-on-backdrop hide-header-close
          ok-variant cancel-variant hide-footer
          header-class="PopUpHeader" 
          :body-bg-variant=PopUpVar.bodyBgVariant
          :body-text-variant=PopUpVar.bodyTextVariant
          :footer-bg-variant=PopUpVar.footerBgVariant
          :footer-text-variant=PopUpVar.footerTextVariant> 
        <ServiceCodePrereqServiceCodesAddEdit  v-if="showEditModal==true" :Codes="ServiceCodes" :UserRow="editedRow" :CurrentCode="serviceCode" :DataSet="tableData" :UserData="UserData" :mode="mode" @PreReqUpdated="UpdateRecord"></ServiceCodePrereqServiceCodesAddEdit>
        
        <template slot="modal-header"> 
            <div>
            <small class="modal-title PopUpTitle w-100 text-left">{{mode}} Prerequisite Service Codes</small>
          </div> 
          <div v-show="mode=='Edit'"><small class="modal-title w-100 text-right"></small></div>
        </template> 
        <div slot="modal-footer" class="w-100"> 
        </div>
      </b-modal> 

        <div  class="row" >
          <div class="col-5">
            <label for="PrereqServiceCodes" class="label-small p-0 m-0">Prerequisite Service Codes:</label>
            <div slot="beforeBody"  class="VueTables_Adduser small"></div>
            <button :disabled="readonly || NoServiceTypes || maxRows" v-on:click="AddPrereqServiceCodesPopup" type="button"  class="btn btn-primary btn-smlb">Add Service Codes</button>
          </div>
            <div class="col-7">
               <v-client-table class="small" :columns="columns" :data="tableData" :options="options">
                 <span class="pointer" v-on:click="DeleteRecordMsgBox('Are you sure you want to delete this Prerequisite Service Codes?'   ,props)" slot="delete" slot-scope="props" ><i class="far fa-trash-alt"></i></span>
                   <span class="pointer" v-on:click="EditPrereqServiceCodesPopup(props)" slot="edit" slot-scope="props" ><i class="far fa-edit"></i></span>
                 </v-client-table> 
            </div> 
                 
        </div>
    </div>
</template>

<script>
import { PopUpVariant } from '@/Common/Default/PopUpVariant';
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import Modal from '../../../Common/ModelPop.vue';
import ServiceCodePrereqServiceCodesAddEdit from '@/components/DPEBB/Administrator/ServiceCodePrereqServiceCodesAddEdit.vue';
const MaxPrerequisiteCodes = 20

export default {
props:{
      Data:'',
      Codes:'',
      ReadOnly:false,
      CurrentCode:'',
    },
     data: function(){
        return {
            PopUpVar:PopUpVariant,
            mode:'',
            showModal:false,
            isValid:false,
            Access:'',
            AllowAdd:false,
            showEditModal:false,
            isValid:'',
            Button:'',
            readonly:false,
            ServiceCodes:[],
            NoServiceTypes:false,
            editedRow:'',
            maxRows:false,
        columns: ['delete','edit','codePrerequisite', 'codeUnitDelay','numUnitDelay'],
        tableData: [],
        options: {
          skin:"table-striped table-bordered table-hover",
        texts:{
              count:"",
              first:'First',
              last:'Name',
              filter:"",
              limit:"Records:",
              page:"Page:",
              noResults:"No matching records",
              filterBy:"Filter by {column}",
              loading:'Loading...',
              defaultOption:'Select {column}',
              columns:'Columns'
          }, 
       
          responseAdapter({data}) {
           
              return {
                data: formatData,
                count: data.length
              };
             
            },
         
          perPage:5,
          perPageValues:[10,15,25],
          dateColumns:['effectivedate','expirydate'],
          toMomentFormat: 'YYYY-MM-DD',
            templates: {
              codeUnitDelay(h, row){
                switch(row.codeUnitDelay){
                  case 'D':
                    return 'Days'
                  case 'M':
                    return 'Months'
                  case 'Y':
                    return 'Years'
                  case 'L':
                    return 'Lifetime'
                  default:
                    return row.codeUnitDelay;
               }
              }
            },

          headings: {
            codePrerequisite: 'Service Code',
            numUnitDelay: 'SC Delay',
            edit:'',
            delete:'',
            codeUnitDelay:'Unit'
          },
          pagination: {
            edge: true,
            nav: 'scroll',
            chunk: 5
          },
          sortable: ['codePrerequisite','numUnitDelay'],
            filterable: '', 
          sortIcon: {
                  base : 'fas',
                  is: 'fa-sort',
                  up: 'fa-sort-up',
                  down: 'fa-sort-down'
                  },
            }       
        }
        
        },
        components: {
          Modal:Modal,
          Card,
          CardBody,
          TileNote,
          ServiceCodePrereqServiceCodesAddEdit
        
        },
        
        created:function(){
            console.log("pre req Codes =  "+ this.Codes.servicecode)
            this.ServiceCodes = this.Codes;
            this.NoServiceTypes = this.ServiceCodes.length <=0;
            console.log("NoServiceTypes "+ this.NoServiceTypes)
            this.tableData = this.Data;
            this.readonly = this.ReadOnly;
            this.maxRows = this.tableData.length == MaxPrerequisiteCodes
            this.serviceCode = this.CurrentCode;
           // console.log("Pre Req Read maxRows "+ this.maxRows) 
            this.tableData.forEach(function(e){
            if (typeof e === "object" &&  e["codeUnitDelay"] == undefined ){
                e["codeUnitDelay"] = "Months";
            }
        })
        },
        mounted() {
            // hide admin column
            if (this.readonly || this.NoServiceTypes)
                  this.columns.splice(this.columns.findIndex(column => column == 'edit'), 1);
            if (this.readonly)
                  this.columns.splice(this.columns.findIndex(column => column == 'delete'), 1);
    },
     methods:{
      DeleteRecordMsgBox(msg,data){
        this.boxTwo = ''
        this.$bvModal.msgBoxConfirm(msg, {
          title: 'Please Confirm',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'danger',
          cancelVariant: 'default',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: true,
          centered: true, 
        })
        .then(value => {
          this.boxTwo = value
          var vm = this;
          if(value)
          {
            this.tableData.splice((data.index -1),1);
            this.maxRows = this.tableData.length == MaxPrerequisiteCodes
            // this.$forceUpdate()
          }
        })
        .catch(err => {
          console.log(err);
        })
      },
      EditPrereqServiceCodesPopup(Rowdata){
          this.editedRow = Rowdata.index -1;
          this.mode='Edit';
          this.UserData = Rowdata.row
          this.showEditModal=true;
      },
      AddPrereqServiceCodesPopup(){
         this.mode='Add';
          this.editedRow = -1;
          this.UserData = '';
          this.showEditModal=true;
      },
      UpdateRecord(value){
        this.showEditModal = false;
        if(this.editedRow != -1){
          this.tableData[this.editedRow].codePrerequisite = value.codePrerequisite;
          this.tableData[this.editedRow].numUnitDelay = value.numUnitDelay;
          console.log(' Unit Delay at pre req' + value.codeUnitDelay)
          this.tableData[this.editedRow].codeUnitDelay = value.codeUnitDelay;
        }
        else{
            this.tableData.push({codePrerequisite:value.codePrerequisite, numUnitDelay:value.numUnitDelay, codeUnitDelay:value.codeUnitDelay.id });
        }
         this.maxRows = this.tableData.length == MaxPrerequisiteCodes
        //this.$emit('ScPreReqFinish', this.tableData);
      },
    }
}
</script>

<style>
#ServiceCodePrereqServiceCodes  .modal-dialog {
    max-width: 70%;
    margin: 0;
    top: 5%;
    bottom: 0;
    left: 20%;
    right: 20%;
    height: 35vh;
    display: flex;
    /* position: fixed; */
    z-index: 100000;
}
</style>
